(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/use-media-query/assets/javascripts/use-media-query.js') >= 0) return;  svs.modules.push('/components/lb-utils/use-media-query/assets/javascripts/use-media-query.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useLayoutEffect = _React.useLayoutEffect,
  useState = _React.useState;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery.breakpoints,
  only = _svs$components$lbUti.only,
  values = _svs$components$lbUti.values;
const useMediaQuery = queryInput => {
  const query = queryInput.replace(/^@media( ?)/m, '');
  const _useState = useState(() => matchMedia(query).matches),
    _useState2 = _slicedToArray(_useState, 2),
    match = _useState2[0],
    setMatch = _useState2[1];
  useLayoutEffect(() => {
    const queryList = matchMedia(query);
    const updateMatch = () => {
      setMatch(queryList.matches);
    };
    updateMatch();
    queryList.addListener(updateMatch);
    return () => {
      queryList.removeListener(updateMatch);
    };
  }, [query]);
  return match;
};
const useMediaQueryWatcher = () => {
  const entries = Array.from(values.keys()).map(key => {
    const query = only(key).replace(/^@media( ?)/m, '');
    const queryList = matchMedia(query);
    return {
      key,
      queryList,
      onChange: null
    };
  });
  const _useState3 = useState(() => entries.find(_ref => {
      let queryList = _ref.queryList;
      return queryList.matches;
    }).key),
    _useState4 = _slicedToArray(_useState3, 2),
    match = _useState4[0],
    setMatch = _useState4[1];
  useLayoutEffect(() => {
    entries.forEach(entry => {
      entry.onChange = event => {
        if (event.matches) {
          setMatch(entry.key);
        }
      };
      entry.queryList.addEventListener('change', entry.onChange);
    });
    return () => {
      entries.forEach(entry => entry.queryList.removeEventListener('change', entry.onChange));
    };
  }, [entries]);
  return match;
};
setGlobal('svs.components.lbUtils.useMediaQuery.useMediaQueryWatcher', useMediaQueryWatcher);
setGlobal('svs.components.lbUtils.useMediaQuery.useMediaQuery', useMediaQuery);

 })(window);